(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require(undefined));
	else if(typeof define === 'function' && define.amd)
		define(["plesk-ui-library"], factory);
	else if(typeof exports === 'object')
		exports["Jsw"] = factory(require(undefined));
	else
		root["Jsw"] = factory(root[undefined]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 153);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** external {"amd":"plesk-ui-library"} ***!
  \*******************************************/
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 107:
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./app/cloud-backup-restriction/CloudBackupRestriction.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2018. Plesk International GmbH. All rights reserved.

var CloudBackupRestriction = function (_Component) {
    _inherits(CloudBackupRestriction, _Component);

    function CloudBackupRestriction() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CloudBackupRestriction);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CloudBackupRestriction.__proto__ || Object.getPrototypeOf(CloudBackupRestriction)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            visible: true
        }, _this.handleClose = function () {
            _this.setState({
                visible: false
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CloudBackupRestriction, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps() {
            this.setState({
                visible: true
            });
        }
    }, {
        key: "render",
        value: function render() {
            return (0, _uiLibrary.createElement)(
                _uiLibrary.Dialog,
                {
                    isOpen: this.state.visible,
                    size: "sm",
                    banner: Jsw.skinUrl + "/images/plesk-backup.png",
                    cancelTitle: (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: "closeButton" }),
                    buttons: this.props.buyUrl ? (0, _uiLibrary.createElement)(
                        _uiLibrary.Button,
                        {
                            intent: "primary",
                            icon: "shopping-cart",
                            component: "a",
                            href: this.props.buyUrl,
                            target: this.props.buyUrlNewWindow ? '_blank' : false,
                            onClose: this.handleClose
                        },
                        (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: "buyButton" })
                    ) : null,
                    onClose: this.handleClose
                },
                (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: this.props.buyUrl ? 'descriptionWithBuy' : 'description' })
            );
        }
    }]);

    return CloudBackupRestriction;
}(_uiLibrary.Component);

CloudBackupRestriction.propTypes = {
    buyUrl: _uiLibrary.PropTypes.string,
    buyUrlNewWindow: _uiLibrary.PropTypes.bool
};
CloudBackupRestriction.defaultProps = {
    buyUrl: null,
    buyUrlNewWindow: true
};

exports.default = CloudBackupRestriction;

/***/ }),

/***/ 153:
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./app/cloud-backup-restriction/index.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 1);

var _CloudBackupRestriction = __webpack_require__(/*! ./CloudBackupRestriction */ 107);

var _CloudBackupRestriction2 = _interopRequireDefault(_CloudBackupRestriction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2018. Plesk International GmbH. All rights reserved.

module.exports = function (_ref) {
    var container = _ref.container,
        locale = _ref.locale,
        props = _objectWithoutProperties(_ref, ['container', 'locale']);

    (0, _uiLibrary.render)((0, _uiLibrary.createElement)(
        _uiLibrary.LocaleProvider,
        { messages: locale },
        (0, _uiLibrary.createElement)(_CloudBackupRestriction2.default, props)
    ), container);
};

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// javascript/app/cloud-backup-restriction.js